export default __webpack_public_path__ + "static/media/2.77fc8554.jpg";